import {
  computed,
  Inject,
  inject,
  Injectable,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { AppService } from './app.service';
import { APIConstant } from '../constants/APIConstants';
import { IRegisterGuestProps } from '../models';
import { lastValueFrom } from 'rxjs';
import { ObjectLiteral } from '../models/ObjectLiteral';
import { LocalService } from './local.service';
import { isPlatformBrowser } from '@angular/common';

export interface IUpdateProfileData {
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  avatar?: any;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private appService = inject(AppService);
  private localService = inject(LocalService);
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    const user = this.localService.getData('visitorms_user');
    const uid = this.localService.getData('visitorms_uid');

    if (user) {
      this.userData.set(user);
    }
    this.uid.set(uid);
  }

  userData = signal<any>(null);

  hasValidToken = (): boolean => {
    if (isPlatformBrowser(this.platformId)) {
      // do stuff, return true or false
      const user = this.localService.getData('visitorms_user');
      if (!user) return false;
      return true;
    }
    return null; // >>>>>>>>>>>>>>>>>>>>>> needed to add this!
  };

  uid = signal<any>(null);
  setUserData(arg) {
    this.userData.set(arg);
    this.localService.saveData('visitorms_user', JSON.stringify(arg));
  }
  setUserId(arg) {
    this.uid.set(arg);
    this.localService.saveData('visitorms_uid', JSON.stringify(arg));
  }
  setPreRegData(arg) {
    this.localService.saveData('visitorms_prereg', JSON.stringify(arg));
  }

  getPreRegData() {
    const data = this.localService.getData('visitorms_prereg');

    if (!data) {
      return null;
    }
    return data;
  }
  getUserData() {
    const user = this.localService.getData('visitorms_user');

    if (!user) {
      return null;
    }
    this.userData.set(user);
    return user;
  }

  isLoggedInSignal = computed(() => {
    return !!this.userData();
  });

  get isLoggedIn() {
    return !!this.userData();
  }

  get userRole() {
    return this.userData()?.role;
  }

  get isCheckinAdmin() {
    return this.userRole === 'checkin';
  }

  get isStaff() {
    return this.userRole === 'staff';
  }

  get isAppointmentAdmin() {
    return this.userRole === 'appointment';
  }

  get isSuperadmin() {
    return this.userRole === 'superadmin';
  }

  clearUserData() {
    console.log('CLEARED~!!!!!!!');
    this.userData.set(null);
    this.localService.clearData();
  }

  login(data: ObjectLiteral) {
    return lastValueFrom(
      this.appService.post(`${APIConstant.auth.login}`, data),
    );
  }

  contactUs(data: ObjectLiteral) {
    return lastValueFrom(
      this.appService.post(`${APIConstant.auth.contactUs}`, data),
    );
  }

  resetPasswordRequest(data: { email: string }) {
    return lastValueFrom(
      this.appService.post(`${APIConstant.auth.sendPasswordResetEmail}`, data),
    );
  }

  resetPassword(data: { email: string }) {
    return lastValueFrom(
      this.appService.put(`${APIConstant.auth.resetPassword}`, data),
    );
  }

  verifyEmail(token: string) {
    return lastValueFrom(
      this.appService.get(`${APIConstant.auth.verifyEmail}`, { token }),
    );
  }

  register(data: ObjectLiteral): Promise<any> {
    return lastValueFrom(
      this.appService.post(`${APIConstant.auth.register}`, data),
    );
  }

  changePassword(data: {
    password: string;
    confirmPassword: string;
    oldPassword: string;
  }) {
    return lastValueFrom(
      this.appService.put(`${APIConstant.auth.changePassword}`, data),
    );
  }

  updateProfile(data: IUpdateProfileData) {
    return lastValueFrom(
      this.appService.put(`${APIConstant.auth.updateProfile}`, data),
    );
  }
}
